import {
  APP_INITIALIZER,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { UnauthenticatedConfigService } from '@mds/ngx-core';
import { AppInsightsService } from '@mds/ngx-diagnostics';
import { filter, first, map, Observable, tap } from 'rxjs';
import {
  ApplicationInsightsConfig,
  ConfigResponse,
} from '../../shared/services/api-client';

export function provideAppInsight(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: initAppInsight,
      deps: [AppInsightsService, UnauthenticatedConfigService],
      multi: true,
    },
  ]);
}

function initAppInsight(
  appInsightsService: AppInsightsService,
  configService: UnauthenticatedConfigService<ConfigResponse>,
): () => Observable<ApplicationInsightsConfig | undefined> {
  return () =>
    configService.config$.pipe(
      filter((config): config is ConfigResponse => !!config),
      first(),
      map((x) => x.applicationInsights),
      tap((appInsights) => {
        if (!appInsights) return;

        appInsightsService.init({
          config: {
            connectionString: appInsights.connectionString,
            enableCorsCorrelation: true,
          },
        });
      }),
    );
}
